import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: () =>
            import('@/views/index/index'),
      redirect: '/certificate/index',
      children:[
        {
          path: '/certificate/index',
          component: () =>
                import('@/views/certificate/index'),
        },
        {
          path:'/classes/index',
          component: () =>
                import('@/views/classes/index'),
        },
        {
          path:'/evaluationCenter/index',
          component: () =>
                import('@/views/evaluationCenter/index'),
        },
        {
          path:'/cooperation/index',
          component: () =>
                import('@/views/cooperation/index'),
        },
        {
          path:'/cooperationDetail/index',
          component: () =>
                import('@/views/cooperationDetail/index'),
        },
        {
          path:'/classesDetail/index',
          component: () =>
                import('@/views/classesDetail/index'),
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js